// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Form_update-form__P8nyl .Form_mapped-profile__otYjV {
  margin-top: 3px;
  display: flex;
  padding: 10px 15px;
  justify-content: space-between;
  align-items: flex-start;
  background: white;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
}
.Form_update-form__P8nyl .Form_mapped-profile__otYjV .Form_profile-summary__t4m2b {
  display: flex;
}
.Form_update-form__P8nyl .Form_mapped-profile__otYjV .Form_profile-summary__t4m2b .Form_profile-img__aFHuL img {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  object-fit: cover;
}
.Form_update-form__P8nyl .Form_mapped-profile__otYjV .Form_profile-summary__t4m2b .Form_profile-info__x9okN {
  margin-left: 10px;
  color: #6f6f6f;
}
.Form_update-form__P8nyl .Form_mapped-profile__otYjV .Form_profile-summary__t4m2b .Form_profile-info__x9okN .Form_profile-name__crDH2 {
  color: black;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 10px !important;
}
.Form_update-form__P8nyl .Form_mapped-profile__otYjV .Form_navigate-mapped-profile__XdGxC {
  color: var(--profile-management-color);
  display: flex;
  align-items: center;
  cursor: pointer;
}
.Form_update-form__P8nyl .Form_mapped-profile__otYjV .Form_navigate-mapped-profile__XdGxC svg {
  margin-left: 5px;
}
.Form_update-form__P8nyl .Form_update-button__d4leT {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Pages/AccountDetail/Components/Form/Form.module.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAAJ;AACI;EACE,aAAA;AACN;AACQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AACV;AAEM;EACE,iBAAA;EACA,cAAA;AAAR;AACQ;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;AACV;AAGI;EACE,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AADN;AAEM;EACE,gBAAA;AAAR;AAIE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;AAFJ","sourcesContent":[".update-form {\n  .mapped-profile {\n    margin-top: 3px;\n    display: flex;\n    padding: 10px 15px;\n    justify-content: space-between;\n    align-items: flex-start;\n    background: white;\n    border-radius: 5px;\n    border: 1px solid #d9d9d9;\n    .profile-summary {\n      display: flex;\n      .profile-img {\n        img {\n          width: 80px;\n          height: 80px;\n          border-radius: 10px;\n          object-fit: cover;\n        }\n      }\n      .profile-info {\n        margin-left: 10px;\n        color: #6f6f6f;\n        .profile-name {\n          color: black;\n          font-weight: 600;\n          font-size: 16px;\n          margin-bottom: 10px !important;\n        }\n      }\n    }\n    .navigate-mapped-profile {\n      color: var(--profile-management-color);\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      svg {\n        margin-left: 5px;\n      }\n    }\n  }\n  .update-button {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    padding: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"update-form": `Form_update-form__P8nyl`,
	"mapped-profile": `Form_mapped-profile__otYjV`,
	"profile-summary": `Form_profile-summary__t4m2b`,
	"profile-img": `Form_profile-img__aFHuL`,
	"profile-info": `Form_profile-info__x9okN`,
	"profile-name": `Form_profile-name__crDH2`,
	"navigate-mapped-profile": `Form_navigate-mapped-profile__XdGxC`,
	"update-button": `Form_update-button__d4leT`
};
export default ___CSS_LOADER_EXPORT___;
